__webpack_require__.p = "https://bundle.stayforlong.com/20251107.4/_next/";